import { registerSW } from 'virtual:pwa-register'

let updateServiceWorker: ((reloadPage?: boolean) => Promise<void>) | null = null

export function initPWA() {
  updateServiceWorker = registerSW({
    immediate: true,

    onNeedRefresh() {
      updateServiceWorker?.(true)
    },

    onOfflineReady() {
      console.log('PWA đã sẵn sàng hoạt động offline.')
    },

    onRegistered(registration: any) {
      console.log('Service Worker registered', registration)
    },

    onRegisterError(error: any) {
      console.error('Service Worker registration failed', error)
    },
  })
}

export function forceUpdate() {
  updateServiceWorker?.(true)
}
